export const PBJ_MODEL_QUERY_KEY = "pbj-model" as const;

/**
 * Key prefix for the upcoming-turnover query. Lives in this dependency-free module (rather than beside the
 * hook in usePbjAudit) so the staffing-side publish mutation can invalidate it without importing the whole
 * audit-hooks tree. Prefix-matching covers every cached `(thresholdDays, departmentId)` pair.
 */
export const UPCOMING_TURNOVER_QUERY_KEY = [PBJ_MODEL_QUERY_KEY, "audit", "upcoming-turnover"] as const;
